'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var Provider = require('./components/Provider.js');
var Slider = require('./components/Slider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Swiper = function (props) {
    var render = props.render, items = props.items, sliderClassName = props.sliderClassName, others = tslib_es6.__rest(props, ["render", "items", "sliderClassName"]);
    return (React__default['default'].createElement(Provider.Provider, tslib_es6.__assign({}, others), items && items.map(function (item, idx) { return (React__default['default'].createElement(Slider.Slider, { key: idx + "-swiper-slider", className: sliderClassName || '', index: idx }, render({ values: item }))); })));
};

exports.Swiper = Swiper;
//# sourceMappingURL=Swiper.js.map
